export default __webpack_public_path__ + "static/media/notFound.0e7ad127.svg";